import * as React from 'react';
import './account/MyAccount.css';
import UserContactDetails from './UserContactDetails';
import { BillingAddress, ShippingAddress } from '../domain/AccountData';

interface Props {
    address: ShippingAddress | BillingAddress;
}

class UserAddressDetails extends React.PureComponent<Props> {
    public render(): JSX.Element {
        return (
            <>
                <div className="my-account-tile-col">
                    <span>{this.props.address.name}</span>
                    <span>{this.props.address.address}</span>
                    <span>
                        {this.props.address.postCode} {this.props.address.city}, {this.props.address.country}
                    </span>
                    <span>{this.props.address.state}</span>
                </div>
                {this.renderAddress()}
            </>
        );
    }

    // todo remove try catch when we remove test data from customers table
    private renderAddress = (): JSX.Element | null => {
        try {
            return (
                <>
                    <div className="my-account-tile-col">
                        {'email' in this.props.address && <span>{this.props.address.email}</span>}
                        {'phone' in this.props.address && <span>{this.props.address.phone}</span>}
                    </div>
                    <UserContactDetails
                        name={this.props.address.contact.name}
                        email={this.props.address.contact.email}
                        phone={this.props.address.contact.phone}
                    />
                </>
            );
        } catch (e) {
            return null;
        }

        return null;
    };
}

export default UserAddressDetails;



// WEBPACK FOOTER //
// ./src/view/UserAddressDetails.tsx